import {Http} from '@angular/http';
import {Request} from "../../../request.abstract";
import {Settings} from "../../../settings.model";
import {ReceiversEndpoint} from "./receivers/api.service";

export class StatisticsEndpoint extends Request {
    protected baseId: number;

    constructor(http: Http, settings: Settings, baseId: number) {
        super(http, settings);
        this.baseId = baseId;
    }

    receivers(): ReceiversEndpoint {
        return new ReceiversEndpoint(this.http, this.settings, this.baseId);
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./src/app/shared/api/bases/proxy/statistics/api.service.ts